import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ApolloProvider } from '@apollo/client';
import { BrowserRouter } from "react-router-dom";
import { Helpers } from './config';
import { store } from './reducers/store';
import { Provider } from 'react-redux';
import { SnackbarProvider } from 'notistack';



ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
    <BrowserRouter>
      <ApolloProvider client={Helpers.restClient}>
        <SnackbarProvider maxSnack={3}>
          <App />
        </SnackbarProvider>
      </ApolloProvider>
    </BrowserRouter>,
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
